import React from 'react';
import { IComponentCollapse } from '../../component';
import Accordion from './Accordion';
import { resolveLocaleText } from '../../utils/localeText';

interface IAllForAccordion extends IComponentCollapse {}

const AllForAccordion = function(props: IAllForAccordion) {
  const { list } = props;
  return (
    <div className="all-for-accordion">
      {(list || []).map((one, index) => (
        <Accordion title={resolveLocaleText(one.title, one.title_i18n)} key={index} expand={one.expand}>
          {one.children}
        </Accordion>
      ))}
    </div>
  );
};

export default AllForAccordion;
